import {
    Box,
    Button,
    Container,
    Typography, useMediaQuery, useTheme
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from 'react';
import "react-device-frameset/styles/marvel-devices.min.css";
import "../../../App.css";
import iphone_mockup from "../../../assets/Iphone_mockup_v4.png";
import GetStarted from "../../components/GetStartedComponent";
import { AppBarPadding, BottomPadding } from "../../../utils/helperUtils";
import { theme } from "../../../theme";
import HighlightsComponent from "./HighlightsComponent";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

function CustomerHomeView() {

    const themeX = useTheme();

    const isMobile = useMediaQuery(themeX.breakpoints.down("md"))

    return (
        <Box
            sx={{
                minHeight: '98vh',
                bgcolor: theme.colors.primary
            }}>
            <AppBarPadding pt={5} />
            <Container maxWidth="xl" >
                <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid
                        size={{ xs: 12, md: 6 }}
                        textAlign={'center'}
                    >
                        <>
                            <Typography
                                variant={isMobile ? "h4" : "h3"}
                                mt={isMobile ? 6 : 3}
                                fontWeight={700}
                                color="white"
                            >
                                The Best Vendors are on Sidewalk
                            </Typography>
                            <Typography
                                variant={"h6"}
                                mt={3}
                                color="white"
                            >
                                Find top vendors in real-time, explore their menus, read reviews, and never miss a bite.
                                Save your faves, catch them at Sidewalk events, and vibe where the flavor lives.</Typography>
                        </>
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <HighlightsComponent/>
                    </Grid>
                    <Grid size={{ xs: 12 }} container justifyContent={'center'} mt={5}>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            endIcon={<ArrowCircleRightIcon />}
                            sx={{
                                borderRadius: 5,
                                color: 'white',
                                fontSize: 20,
                            }}
                        >
                            Get Started
                        </Button>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default CustomerHomeView